import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

// Fix B (2026-09-04): pieza "PORQUE SI" del manual: mayusculas con tracking
// amplio + linea en script dorado + divisor con monograma, sobre espresso.
export default function ClosingCta({ onBook }) {
  const { t } = usePublicLang();
  return (
    <section className="py-24 md:py-32 px-5 text-center" style={{ backgroundColor: "var(--brand-dark)" }} data-testid={LANDING.closingCta}>
      <ScrollReveal className="max-w-xl mx-auto flex flex-col items-center">
        <h2 className="font-serif text-2xl md:text-4xl uppercase tracking-[0.22em] text-[#F7F3ED]">
          {t("landing.closing.title")}
        </h2>

        <p
          className="mt-4 text-3xl md:text-5xl text-[var(--brand-gold)]"
          style={{ fontFamily: "'Pinyon Script', cursive" }}
        >
          {t("landing.closing.script")}
        </p>

        <span className="flex items-center gap-4 my-9 w-full max-w-xs" aria-hidden="true">
          <span className="flex-1 h-px bg-[var(--brand-gold)]/45" />
          <span className="font-serif text-lg text-[var(--brand-gold)]">S</span>
          <span className="flex-1 h-px bg-[var(--brand-gold)]/45" />
        </span>

        <p className="text-[11px] uppercase tracking-[0.22em] text-white/70">{t("landing.closing.subtitle")}</p>

        <button
          type="button"
          onClick={onBook}
          className="mt-8 bg-[var(--brand-accent)] text-white text-[11px] font-medium uppercase tracking-[0.18em] px-8 py-3.5 rounded-md hover:opacity-90 active:scale-95 transition-all"
          data-testid={LANDING.closingCtaButton}
        >
          {t("landing.closing.cta")}
        </button>
      </ScrollReveal>
    </section>
  );
}
